import React from 'react'
import './sidemenu.css'
import { SidemenuContainer } from './SidemenuElements';
import CloseIcon from '@mui/icons-material/Close';
import LogoutIcon from '@mui/icons-material/Logout';
import axios from 'axios';
import { Link } from 'react-router-dom';

export default function Sidemenu({isOpen, toggle, setLoginStatus}) {

  const logout = () => {
    if(window.confirm('Sure you want to logout?')){
      logoutServer()
    }
    else{
      return
    }
  }

  const logoutServer = () => {
    let formData = new FormData();
    formData.append('status', 'false')

    axios({
      method: 'post',
      url: 'https://blood147.000webhostapp.com/admin_panel/updateLogin.php/?id=1',
      data: formData,
      config: { headers: {'Content-Type': 'multipart/form-data' }}
    })
    .then(function (response) {
      if(response.data == 'success'){
        setLoginStatus('false')
      }
      else{
        alert('Server issue!!\nPlease try again later!!')
      }
    })
    .catch(function (response) {
        //handle error
        console.log(response)
    });
  }

  return (
    <SidemenuContainer isOpen={isOpen} onClick={toggle}>
      <div className="iconClose" onClick={toggle}><CloseIcon/></div>
      <div className="iconLogout" onClick={() => logout()}><LogoutIcon/></div>
        <div className="sidemenuWrapper">
          <Link to='/' className='link'>
            <div className="item">Dashboard</div>
          </Link>

          <Link to='/overUsers' className='link'>
            <div className="item">User Overview</div>
          </Link>
          
          <Link to='/addUsers' className='link'>
            <div className="item">Add User</div>
          </Link>
          
          <Link to='/overBB' className='link'>
            <div className="item">Blood Banks Overview</div>
          </Link>
          
          <Link to='/addBB' className='link'>
            <div className="item">Add Blood Banks</div>
          </Link>
          
          <Link to='/overBR' className='link'>
            <div className="item">Blood Requests Overview</div>
          </Link>
          
          <Link to='/addBR' className='link'>
            <div className="item">Add Blood Requests</div>
          </Link>
          
          <Link to='/overDP' className='link'>
            <div className="item">Donation Events Overview</div>
          </Link>
          
          <Link to='/addDP' className='link'>
            <div className="item">Add Donation Events</div>
          </Link>
        </div>
    </SidemenuContainer>
  )
}